import { RequestConfig, RequestConfigType } from '@client/common/utils/api/RequestConfig';
import { stringify } from '@client/common/utils/queryParams';

export class Users {
  public static fetch(pageSize = 25, startItem = 0, sort = 'email', sortOrder = 'asc'): RequestConfigType {
    const searchParams = {
      pageSize,
      startItem,
      sort,
      sortOrder,
    };

    return RequestConfig.get(
      `/account/users?${stringify(searchParams)}`,
    );
  }

  public static search(pageSize = 25, startItem = 0, sort = 'email', sortOrder = 'asc', searchQuery: string): RequestConfigType {
    const searchParams: {
      pageSize: number;
      startItem: number;
      sort: string;
      sortOrder: string;
      q?: string;
    } = {
      pageSize,
      startItem,
      sort,
      sortOrder,
    };

    if (searchQuery?.trim()) {
      searchParams.q = searchQuery;
    }

    return RequestConfig.get(
      `/account/users?${stringify(searchParams)}`,
    );
  }
}
